import script from "./WordSwipe.vue?vue&type=script&setup=true&lang=js"
export * from "./WordSwipe.vue?vue&type=script&setup=true&lang=js"

import "./WordSwipe.vue?vue&type=style&index=0&id=6f12b82d&scoped=true&lang=css"

import exportComponent from "/Users/muhammadaziziabdulaziz/Documents/VueProject/reeqzan/reenarafiq/clientapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f12b82d"]])

export default __exports__